import SearchContentHeader from "../ComponentLibrary/WIP/SearchContentHeader";
import { connectLocation } from '../location/LocationConnectors';

const LocationContentHeader = connectLocation((props) => {
  const { t } = props

  const nextProps = {
    ...props,
    title: t(`sds.results_heading1`),
    fieldPlaceholder: t('sds.search_text'),
    fieldName: "publication_id",
  }
  return <SearchContentHeader {...nextProps} />
})

export default LocationContentHeader
